import React from "react";
import PropTypes from "prop-types";


class LoadingView extends React.Component {

    static propTypes = {
        titleText: PropTypes.string.isRequired
    };

    render() {
        return (
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-6">
                        <div className="card text-center mt-4">
                            <div className="card-header border-bottom-box">
                                {this.props.titleText}
                            </div>
                            <div className="card-body">
                                <div className="spinner-grow spinner-grow-sm text-cuvered-pink" />
                                <div className="spinner-grow spinner-grow-sm text-cuvered-purple" />
                                <div className="spinner-grow spinner-grow-sm text-cuvered-dark-blue" />
                                <div className="spinner-grow spinner-grow-sm text-cuvered-blue" />
                                <div className="spinner-grow spinner-grow-sm text-cuvered-light-blue" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


}

export default LoadingView;